import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack, Tooltip } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkAdjustPurchaseTotalCost = ({
  onClick,
  disabled,
  disabledTooltip,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  disabledTooltip?: string;
}) => {
  const { isDarkMode } = useSiteTheme();

  const dropdownItem = (
    <PosDropdownItem
      key="bulk-adjust-purchase-total-cost"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <Stack gap="m" alignItems="center" width="full">
        <Content id={ContentId.AdjustPurchaseTotalCost} />
      </Stack>
    </PosDropdownItem>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip
        contentVariant={isDarkMode ? 'light' : 'dark'}
        triggerContent={<span>{dropdownItem}</span>}
      >
        {disabledTooltip}
      </Tooltip>
    );
  }

  return dropdownItem;
};
